<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Planos IKAcesso</h5>
                <hr>
				<Toolbar class="p-mb-4">
					<template slot="left">
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="abrirNovo"/>
					</template>
				</Toolbar>
				<DataTable :value="planos" :autoLayout="true" :filters="filtros" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped" :rowClass="rowClass">
					<template #header>
						<div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
							<span></span>
							<span class="p-input-icon-left">
								<i class="pi pi-search" />
								<InputText v-model="filtros['global']" placeholder="Filtrar..." />
							</span>
						</div>
					</template>
					<Column field="equipamentos" header="Equipamentos" sortable></Column>
					<Column field="usuarios" header="Usuários" sortable></Column>
					<Column field="operadores" header="Operadores" sortable></Column>
					<Column field="valorMensalAcesso" header="Val. Acesso" dataType="numeric" style="min-width: 8rem">
						<template #body="{data}">
							{{ formatCurrency(data.valorMensalAcesso) }}
						</template>
					</Column>
					<Column field="valorMensalAcessoEscola" header="Val. Escola" dataType="numeric" style="min-width: 8rem">
						<template #body="{data}">
							{{ formatCurrency(data.valorMensalAcessoEscola) }}
						</template>
					</Column>
					<Column field="valorEquipamentoAdicional" header="Equip. Adicional" dataType="numeric" style="min-width: 8rem">
						<template #body="{data}">
							{{ formatCurrency(data.valorEquipamentoAdicional) }}
						</template>
					</Column>
					<Column field="valorUsuarioAdicional" header="Usuário Adicional" dataType="numeric" style="min-width: 8rem">
						<template #body="{data}">
							{{ formatCurrency(data.valorUsuarioAdicional) }}
						</template>
					</Column>
					<Column field="valorOperadorAdicional" header="Operador Adicional" dataType="numeric" style="min-width: 8rem">
						<template #body="{data}">
							{{ formatCurrency(data.valorOperadorAdicional) }}
						</template>
					</Column>
					<Column field="publicado" header="Publicado" sortable>
						<template #body="{data}">
							<label v-if="data.publicado">Sim</label>
							<label v-if="!data.publicado">Não</label>
						</template>
					</Column>
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-eye" title="Detalhes" class="p-button-rounded p-button-info p-mr-2" @click="detalhes(slotProps.data)"/>						<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="!slotProps.data.publicado && !slotProps.data.dataFinal"/>							<Button icon="pi pi-check" title="Publicar" class="p-button-rounded p-button-success p-mr-2" @click="confirmarPublicar(slotProps.data)" v-if="!slotProps.data.publicado"/>
							<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="!slotProps.data.publicado"/>
						</template>
					</Column>
				</DataTable>
			</div>
		</div>

		<!-- Dialog Novo Plano -->
		<Dialog :visible.sync="exibirDialogForm" :header="tituloDialogForm" :modal="true" class="p-fluid" :style="{width: '30vw'}">
			<div class="p-fluid p-formgrid p-grid">
				<div class="p-field p-col-12 p-md-4">
					<label for="equipamentos">Equipamentos</label>
					<InputNumber id="equipamentos" v-model="plano.equipamentos" :min="0" autocomplete="off" :class="{'p-invalid': enviandoForm && plano.equipamentos == null}"/>
					<small class="p-invalid" v-if="enviandoForm && plano.equipamentos == null">Informe a quantidade de equipamentos</small>
				</div>
				<div class="p-field p-col-12 p-md-4">
					<label for="usuarios">Usuários</label>
					<InputNumber id="usuarios" v-model="plano.usuarios" :min="0" autocomplete="off" :class="{'p-invalid': enviandoForm && plano.usuarios == null}"/>
					<small class="p-invalid" v-if="enviandoForm && plano.usuarios == null">Informe a quantidade de usuários</small>
				</div>
				<div class="p-field p-col-12 p-md-4">
					<label for="operadores">Operadores</label>
					<InputNumber id="operadores" v-model="plano.operadores" :min="0" autocomplete="off" :class="{'p-invalid': enviandoForm && plano.operadores == null}"/>
					<small class="p-invalid" v-if="enviandoForm && plano.operadores == null">Informe a quantidade de operadores</small>
				</div>
				<div class="p-col-12"><hr></div>
				<div class="p-col-12"><h6>Valor Mensal</h6></div>
				<div class="p-field p-col-12 p-md-6">
					<label for="valorMensalAcesso">Valor Acesso</label>
					<InputNumber id="valorMensalAcesso" v-model="plano.valorMensalAcesso" mode="currency" currency="BRL" locale="pt-BR" :min="0" autocomplete="off" :class="{'p-invalid': enviandoForm && plano.valorMensalAcesso == null}"/>
					<small class="p-invalid" v-if="enviandoForm && plano.valorMensalAcesso == null">Informe o valor acesso</small>
				</div>
				<div class="p-field p-col-12 p-md-6">
					<label for="valorMensalAcessoRef">Valor Acesso + Ctrl. Refeição</label>
					<InputNumber id="valorMensalAcessoRef" v-model="plano.valorMensalAcessoRef" mode="currency" currency="BRL" locale="pt-BR" :min="0" autocomplete="off" :class="{'p-invalid': enviandoForm && plano.valorMensalAcessoRef == null}"/>
					<small class="p-invalid" v-if="enviandoForm && plano.valorMensalAcessoRef == null">Informe o valor acesso + ctrl. refeição</small>
				</div>
				<div class="p-field p-col-12 p-md-6">
					<label for="valorMensalAcessoEscola">Valor Acesso + Escola</label>
					<InputNumber id="valorMensalAcessoEscola" v-model="plano.valorMensalAcessoEscola" mode="currency" currency="BRL" locale="pt-BR" :min="0" autocomplete="off" :class="{'p-invalid': enviandoForm && plano.valorMensalAcessoEscola == null}"/>
					<small class="p-invalid" v-if="enviandoForm && plano.valorMensalAcessoEscola == null">Informe o valor acesso + escola</small>
				</div>
				<div class="p-field p-col-12 p-md-6">
					<label for="valorMensalAcessoRefEscola">Valor Acesso + Ctrl. Ref. + Escola</label>
					<InputNumber id="valorMensalAcessoRefEscola" v-model="plano.valorMensalAcessoRefEscola" mode="currency" currency="BRL" locale="pt-BR" :min="0" autocomplete="off" :class="{'p-invalid': enviandoForm && plano.valorMensalAcessoRefEscola == null}"/>
					<small class="p-invalid" v-if="enviandoForm && plano.valorMensalAcessoRefEscola == null">Informe o valor acesso + ctrl. ref. + escola</small>
				</div>
				<div class="p-col-12"><hr></div>
				<div class="p-col-12"><h6>Valor Adicional</h6></div>
				<div class="p-field p-col-12 p-md-4">
					<label for="valorEquipamentoAdicional">Equipamentos</label>
					<InputNumber id="valorEquipamentoAdicional" v-model="plano.valorEquipamentoAdicional" mode="currency" currency="BRL" locale="pt-BR" :min="0" autocomplete="off" :class="{'p-invalid': enviandoForm && plano.valorEquipamentoAdicional == null}"/>
					<small class="p-invalid" v-if="enviandoForm && plano.valorEquipamentoAdicional == null">Informe o valor p/ equipamento adicional</small>
				</div>
				<div class="p-field p-col-12 p-md-4">
					<label for="valorUsuarioAdicional">Usuários</label>
					<InputNumber id="valorUsuarioAdicional" v-model="plano.valorUsuarioAdicional" mode="currency" currency="BRL" locale="pt-BR" :min="0" autocomplete="off" :class="{'p-invalid': enviandoForm && plano.valorUsuarioAdicional == null}"/>
					<small class="p-invalid" v-if="enviandoForm && plano.valorUsuarioAdicional == null">Informe o valor p/ usuário adicional</small>
				</div>
				<div class="p-field p-col-12 p-md-4">
					<label for="valorOperadorAdicional">Operadores</label>
					<InputNumber id="valorOperadorAdicional" v-model="plano.valorOperadorAdicional" mode="currency" currency="BRL" locale="pt-BR" :min="0" autocomplete="off" :class="{'p-invalid': enviandoForm && plano.valorOperadorAdicional == null}"/>
					<small class="p-invalid" v-if="enviandoForm && plano.valorOperadorAdicional == null">Informe o valor p/ operador adicional</small>
				</div>
			</div>
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharDialogForm"/>
				<Button label="Salvar" icon="pi pi-check" class="p-button-primary" @click="salvar"/>
			</template>
		</Dialog>

		<!-- Dialog Detalhes -->
		<Dialog :visible.sync="exibirDialogDetalhes" header="Detalhes do Plano" :modal="true" :style="{width: '45vw'}">
			<div class="p-fluid p-formgrid p-grid" v-if="planoSelecionado">
				<div class="p-field p-col-12 p-md-6">
					<label><b>Equipamentos:</b></label>
					<span class="p-ml-2">{{ planoSelecionado.equipamentos }}</span>
				</div>
				<div class="p-field p-col-12 p-md-6">
					<label><b>Usuários:</b></label>
					<span class="p-ml-2">{{ planoSelecionado.usuarios }}</span>
				</div>
				<div class="p-field p-col-12 p-md-6">
					<label><b>Operadores:</b></label>
					<span class="p-ml-2">{{ planoSelecionado.operadores }}</span>
				</div>
				<div class="p-col-12"><hr></div>
				<div class="p-col-12"><h6>Valor Mensal</h6></div>
				<div class="p-field p-col-12 p-md-6">
					<label><b>Valor Acesso:</b></label>
					<span class="p-ml-2">{{ formatCurrency(planoSelecionado.valorMensalAcesso) }}</span>
				</div>
				<div class="p-field p-col-12 p-md-6">
					<label><b>Valor Acesso + Ctrl. Refeição:</b></label>
					<span class="p-ml-2">{{ formatCurrency(planoSelecionado.valorMensalAcessoRef) }}</span>
				</div>
				<div class="p-field p-col-12 p-md-6">
					<label><b>Valor Acesso + Escola:</b></label>
					<span class="p-ml-2">{{ formatCurrency(planoSelecionado.valorMensalAcessoEscola) }}</span>
				</div>
				<div class="p-field p-col-12 p-md-6">
					<label><b>Valor Acesso + Ctrl. Ref. + Escola:</b></label>
					<span class="p-ml-2">{{ formatCurrency(planoSelecionado.valorMensalAcessoRefEscola) }}</span>
				</div>
				<div class="p-col-12"><hr></div>
				<div class="p-col-12"><h6>Valor Adicional</h6></div>
				<div class="p-field p-col-12 p-md-4">
					<label><b>Equipamentos:</b></label>
					<span class="p-ml-2">{{ formatCurrency(planoSelecionado.valorEquipamentoAdicional) }}</span>
				</div>
				<div class="p-field p-col-12 p-md-4">
					<label><b>Usuários:</b></label>
					<span class="p-ml-2">{{ formatCurrency(planoSelecionado.valorUsuarioAdicional) }}</span>
				</div>
				<div class="p-field p-col-12 p-md-4">
					<label><b>Operadores:</b></label>
					<span class="p-ml-2">{{ formatCurrency(planoSelecionado.valorOperadorAdicional) }}</span>
				</div>
				<div class="p-col-12"><hr></div>
				<div class="p-field p-col-12 p-md-4">
					<label><b>Publicado:</b></label>
					<span class="p-ml-2">{{ planoSelecionado.publicado ? 'Sim' : 'Não' }}</span>
				</div>
			</div>
			<template #footer>
				<Button label="Fechar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogDetalhes = false"/>
			</template>
		</Dialog>

		<!-- Dialog Confirmar Publicar -->
		<Dialog :visible.sync="exibirDialogPublicar" header="Confirmar Publicação" :modal="true" :style="{width: '450px'}">
			<div class="confirmation-content">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color: orange" />
				<span>Publicar este plano? O plano atual será finalizado e receberá a data final.</span>
			</div>
			<div class="p-mt-3" v-if="planoSelecionado">
				<p><b>Equipamentos:</b> {{ planoSelecionado.equipamentos }}</p>
				<p><b>Usuários:</b> {{ planoSelecionado.usuarios }}</p>
				<p><b>Operadores:</b> {{ planoSelecionado.operadores }}</p>
				<p><b>Val. Acesso:</b> {{ formatCurrency(planoSelecionado.valorMensalAcesso) }}</p>
				<p><b>Val. Acesso + Ctrl. Ref.:</b> {{ formatCurrency(planoSelecionado.valorMensalAcessoRef) }}</p>
				<p><b>Val. Acesso + Escola:</b> {{ formatCurrency(planoSelecionado.valorMensalAcessoEscola) }}</p>
				<p><b>Val. Acesso + Ctrl. Ref. + Escola:</b> {{ formatCurrency(planoSelecionado.valorMensalAcessoRefEscola) }}</p>
				<p><b>Equip. Adicional:</b> {{ formatCurrency(planoSelecionado.valorEquipamentoAdicional) }}</p>
				<p><b>Usuário Adicional:</b> {{ formatCurrency(planoSelecionado.valorUsuarioAdicional) }}</p>
				<p><b>Operador Adicional:</b> {{ formatCurrency(planoSelecionado.valorOperadorAdicional) }}</p>
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogPublicar = false"/>
				<Button label="Sim" icon="pi pi-check" class="p-button-success" @click="publicar"/>
			</template>
		</Dialog>

		<!-- Dialog Confirmar Excluir -->
		<Dialog :visible.sync="exibirDialogExcluir" header="Confirmar Exclusão" :modal="true" :style="{width: '450px'}">
			<div class="confirmation-content">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color: red" />
				<span>Excluir este plano?</span>
			</div>
			<div class="p-mt-3" v-if="planoSelecionado">
				<p><b>Equipamentos:</b> {{ planoSelecionado.equipamentos }}</p>
				<p><b>Usuários:</b> {{ planoSelecionado.usuarios }}</p>
				<p><b>Operadores:</b> {{ planoSelecionado.operadores }}</p>
				<p><b>Val. Acesso:</b> {{ formatCurrency(planoSelecionado.valorMensalAcesso) }}</p>
				<p><b>Val. Acesso + Ctrl. Ref.:</b> {{ formatCurrency(planoSelecionado.valorMensalAcessoRef) }}</p>
				<p><b>Val. Acesso + Escola:</b> {{ formatCurrency(planoSelecionado.valorMensalAcessoEscola) }}</p>
				<p><b>Val. Acesso + Ctrl. Ref. + Escola:</b> {{ formatCurrency(planoSelecionado.valorMensalAcessoRefEscola) }}</p>
				<p><b>Equip. Adicional:</b> {{ formatCurrency(planoSelecionado.valorEquipamentoAdicional) }}</p>
				<p><b>Usuário Adicional:</b> {{ formatCurrency(planoSelecionado.valorUsuarioAdicional) }}</p>
				<p><b>Operador Adicional:</b> {{ formatCurrency(planoSelecionado.valorOperadorAdicional) }}</p>
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogExcluir = false"/>
				<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir"/>
			</template>
		</Dialog>
    </div>
</template>

<script>

import PlanoIKAcessoService from '@/service/PlanoIKAcessoService';
import PlanoIKAcesso from '@/model/PlanoIKAcesso';
import { exibirMensagem, exibirMensagemSis } from '@/global';

export default {
    planoService: null,
    data() {
        return {
            planos: [],
            plano: new PlanoIKAcesso(),
            planoSelecionado: null,
            filtros: {},           
            enviandoForm: false,
            editando: false,
            tituloDialogForm: 'Novo Plano IKAcesso',
            exibirDialogForm: false,
            exibirDialogDetalhes: false,
            exibirDialogPublicar: false,
            exibirDialogExcluir: false,
        }
    },
    methods: {
        listar() {            
            this.planoService.listarTodos()
                .then(resp => {
                    this.planos = resp.data;                   
                })
                .catch(erro => {                   
                    exibirMensagem(this, erro);
                });
        },
        abrirNovo() {
            this.plano = new PlanoIKAcesso();
            this.enviandoForm = false;
            this.editando = false;
            this.tituloDialogForm = 'Novo Plano IKAcesso';
            this.exibirDialogForm = true;
        },
        editar(plano) {
            this.plano = {...plano};
            this.enviandoForm = false;
            this.editando = true;
            this.tituloDialogForm = 'Editar Plano IKAcesso';
            this.exibirDialogForm = true;
        },
        salvar() {
            this.enviandoForm = true;
            if (this.plano.equipamentos == null || this.plano.usuarios == null || this.plano.operadores == null
                || this.plano.valorMensalAcesso == null || this.plano.valorMensalAcessoRef == null
                || this.plano.valorMensalAcessoEscola == null || this.plano.valorMensalAcessoRefEscola == null
                || this.plano.valorEquipamentoAdicional == null || this.plano.valorUsuarioAdicional == null
                || this.plano.valorOperadorAdicional == null) {
                return;
            }
            let request = this.editando
                ? this.planoService.alterar(this.plano)
                : this.planoService.salvar(this.plano);
            request
                .then(() => {
                    this.enviandoForm = false;
                    this.fecharDialogForm();
                    this.listar();
                    exibirMensagemSis(this, 'Sucesso', false);
                })
                .catch(erro => { exibirMensagem(this, erro) });
        },
        detalhes(plano) {
            this.planoSelecionado = plano;
            this.exibirDialogDetalhes = true;
        },
        confirmarPublicar(plano) {
            this.planoSelecionado = plano;
            this.exibirDialogPublicar = true;
        },
        publicar() {
            this.planoService.publicar(this.planoSelecionado.id)
                .then(() => {
                    this.exibirDialogPublicar = false;
                    this.listar();
                    exibirMensagemSis(this, 'Sucesso', false);
                })
                .catch(erro => { exibirMensagem(this, erro) });
        },
        confirmarExcluir(plano) {
            this.planoSelecionado = plano;
            this.exibirDialogExcluir = true;
        },
        excluir() {
            this.planoService.excluir(this.planoSelecionado.id)
                .then(() => {
                    this.exibirDialogExcluir = false;
                    this.listar();
					exibirMensagemSis(this, 'Plano excluído com sucesso', false);
                })
                .catch(erro => { exibirMensagem(this, erro) });
        },
        fecharDialogForm() {
            this.exibirDialogForm = false;
            this.plano = new PlanoIKAcesso();
            this.enviandoForm = false;
            this.editando = false;
        },
        formatCurrency(value) {
            if (value == null) return '';
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        formatDate(value) {
            if (!value) return '';
            const date = new Date(value);
            return date.toLocaleDateString('pt-BR');
        },
        formatDateTime(value) {
            if (!value) return '';
            const date = new Date(value);
            return date.toLocaleDateString('pt-BR') + ' ' + date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        },
        rowClass(data) {
            if (!data.publicado) return 'row-plano-nao-publicado';
            if (!data.dataFinal) return 'row-plano-ativo';
            return '';
        },
    },
    created() {
        this.planoService = new PlanoIKAcessoService();
    },
    mounted() {
        this.listar();
    }
}
</script>

<style scoped>
::v-deep .row-plano-ativo {
    background-color: #c8e6c9 !important;
    font-weight: bold;
}
::v-deep .row-plano-nao-publicado {
    background-color: #fff9c4 !important;
    font-weight: bold;
}
</style>